const SegaConsoleLinks = [
    {
        name: 'Master System',
        url: 'master-system'
    },
    {
        name: 'Sega Genesis',
        url: 'sega-genesis'
    },
    {
        name: 'Sega Saturn',
        url: 'sega-saturn'
    },
    // {
    //     name: 'Dreamcast',
    //     url: 'dreamcast'
    // }
];

module.exports = {SegaConsoleLinks};